module.exports = __webpack_public_path__ + "static/img/3.8ed8e1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/3.jpg
// module id = Liay
// module chunks = 0